<template>
    <stats-card :title="title"
                :type="'gradient-'+type"
                :sub-title="annualServicesCourtesyTotal.toString()"
                :icon="showHeader ? '' : 'fad fa-balance-scale'"
                class="mb-4 mb-xl-0">
        <template v-slot:header v-if="showHeader">
            <router-link :to="{ name: 'Leistungen' }" class="router-link">
                <div class="row align-items-center">
                    <div class="col">
                        <h6 class="text-uppercase text-muted ls-1 mb-1">CRM</h6>
                    </div>
                    <div class="col-auto">
                        <div class="icon icon-shape"><i class="far fa-balance-scale text-danger" aria-hidden="true"></i></div>
                    </div>
                </div>
                <hr class="mb-3 mt-1">
            </router-link>
        </template>
            <span v-if="error.length > 0" class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        <template v-slot:footer></template>
    </stats-card>
</template>
<script>
import {ref, onMounted} from 'vue';
import UserService from '@/services/user.service';
import moment from 'moment';

export default {
    name: 'ServicesYearCourtesyTotal',
    components: {},
    props: {
        type: {
            type: String,
            default: "info"
        },
        title: {
            type: String,
            default: "Kulanz Betrag (aktuelles Jahr)"
        },
        showHeader: {
            type: Boolean,
            default: false
        }
    },
    setup() {

        const error = ref('');

        function getError(request) {
            if (request.response && request.response.status == '401') {
                error.value = 'you are not logged in!';
            } else if (request.response && request.response.status == '403') {
                error.value = 'you are not permitted!';
            } else {
                error.value =
                    (request.response && request.response.data) ||
                    request.message ||
                    request.toString();
            }
        }

        const annualServicesCourtesyTotal = ref(0.0)

        function getServices() {
            UserService.getServices().then(
                response => {
                    response.data.data.map(service => {
                        if(moment(service.projectDate, 'DD.MM.YYYY').format('YYYY') === moment().format('YYYY') && service.billingType.includes('Kulant')) {
                            annualServicesCourtesyTotal.value += parseFloat(service.amount)
                        }
                    });
                    annualServicesCourtesyTotal.value = parseFloat(annualServicesCourtesyTotal.value).toLocaleString('de-CH', {
                        style: 'currency',
                        currency: 'CHF'
                    })

                    error.value = '';
                },
                error => {
                    getError(error);
                }
            );
        }

        onMounted(() => {
            getServices();
        });

        return {
            error,
            annualServicesCourtesyTotal,
        }
    }
}
</script>

<style lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}
</style>
